<template lang="pug">
.ticket-duo(:class="color")
  img(:src="iconSrc")
  .text {{ text }}
</template>

<script>

export default {
  name: 'HighlightedTicket',
  computed: {
    iconSrc () {
      return require(`@/assets/imagesnew/${this.icon}`)
    }
  },
  props: {
    color: {
      type: String,
      default: 'aqua'
    },
    text: {
      type: String,
      default: 'Focus on leveraging data available online'
    },
    icon: {
      type: String,
      default: 'online-data.jpg'
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

$color-title: #364149;
$color-subtitle: #767F86;
.ticket-duo {
  max-width: 465px;
  height: 160px;
  display: flex;
  flex-direction: row;
  background: #FFFFFF;
  box-shadow: 8px 9px 55px rgba(118, 127, 134, 0.15);
  border-radius: 5px;
  align-items: center;
  padding-right: 44px;
  img {
    margin: 35px;
  }
  .text {
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 26px;
    color: #767F86;
  }
}
.aqua {
  border-bottom: #36C2CF 5px solid;
}
.blue {
  border-bottom: #5473E8 5px solid;
}

</style>
